import { useEffect, useState } from "react"

import { App, Flex, Modal, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"

import Icon from "../../Icon"
import UserActions from "../User/reducer"
import HowDidYouFindUsForm from "./components/HowDidYouFindUsForm"
import { markAttributionPromptAsShown, sendHowDidYouFindUsData } from "./services"

import "./styles.less"

const { Text } = Typography

const HowDidYouFindUsModal = () => {
  const { notification } = App.useApp()
  const dispatch = useDispatch()
  const { userInfo } = useSelector((state) => state.auth)
  const [open, setOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const { is_attribution_prompt_shown } = userInfo || {}

  const markAsShown = async () => {
    await markAttributionPromptAsShown()
    dispatch(UserActions.userRequest())
  }

  useEffect(() => {
    if (is_attribution_prompt_shown) {
      setOpen(true)
      markAsShown()
    }
  }, [])

  const [isValid, setIsValid] = useState(false)

  const submitForm = async (data) => {
    setIsSubmitting(true)
    const res = await sendHowDidYouFindUsData(data)

    if (res.ok) {
      notification.success({
        message: "Thank you!",
        description: "Your response has been recorded.",
        closeIcon: <Text>{t("Dismiss")}</Text>
      })
    } else {
      notification.error({
        message: "Error",
        description: res.data?.message?.detail || "Something went wrong.",
        closeIcon: <Text>{t("Dismiss")}</Text>
      })
    }

    dispatch(UserActions.userRequest())
    setIsSubmitting(false)
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      width={isMobile ? "100%" : 890}
      classNames={{ content: "clear-bg" }}
      centered={!isMobile}
      wrapClassName={isMobile ? "ob-modal-bottom" : ""}
      {...(isMobile ? { transitionName: "" } : null)}
      title={
        <Flex vertical gap={8}>
          <Text className="title">Where did you first hear about us?</Text>
          <Text type="secondary">
            Takes 3 seconds. Help us understand how you found us - it helps us serve you better.
          </Text>
        </Flex>
      }
      closeIcon={<Icon type="cross_small" />}
      rootClassName="where-did-you-hear-about-us-modal"
      getContainer={() => document.querySelector(".main-container")}
      okText="Confirm"
      cancelText="Ask me later"
      okButtonProps={{
        disabled: !isValid,
        form: "how-did-you-find-us-form",
        size: "large",
        htmlType: "submit",
        loading: isSubmitting,
        style: isMobile ? { width: "100%" } : undefined
      }}
      cancelButtonProps={{
        size: "large",
        style: isMobile ? { width: "100%" } : undefined
      }}
      onCancel={() => setOpen(false)}
    >
      <HowDidYouFindUsForm setIsValidForm={setIsValid} onSubmit={submitForm} />
    </Modal>
  )
}

export default HowDidYouFindUsModal
